import { useState } from "react";
import { Instagram, MapPin, Send } from "lucide-react";
import { CONTACT } from "@/data/teamData";

const WA_NUMBER = "6282115471241"; // +62 821-1547-1241

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const onSubmit = (e) => {
    e.preventDefault();
    const text =
      `Halo The 30s FF! 👋\n\n` +
      `Nama: ${form.name}\n` +
      `Email: ${form.email}\n\n` +
      `${form.message}`;
    window.open(`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`, "_blank", "noopener");
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <section id="kontak" data-testid="contact-section" className="bg-[#0A1128] text-white relative overflow-hidden">
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-[#E63946]/10 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-24 relative z-10 grid lg:grid-cols-12 gap-10">
        {/* Info */}
        <div className="lg:col-span-5 space-y-8">
          <div>
            <div className="text-xs font-bold tracking-[0.3em] text-[#E63946] mb-3">SAPA TIM</div>
            <h2 className="font-display text-5xl sm:text-6xl leading-none">
              MARI <span className="text-[#E63946]">BICARA</span>
            </h2>
            <p className="mt-4 text-white/70 max-w-md">
              Mau ngajak sparring, gabung sebagai sponsor, atau sekedar say hi?
              Hubungi tim kami kapan aja.
            </p>
          </div>

          <div className="space-y-4">
            {[
              { Icon: Instagram, label: "Instagram", value: CONTACT.instagram, href: CONTACT.instagramUrl },
              { Icon: MapPin, label: "Markas", value: CONTACT.base, href: "#" },
            ].map((c, i) => (
              <a
                key={i}
                href={c.href}
                target={c.href?.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer noopener"
                data-testid={`contact-info-${i}`}
                className="flex items-center gap-4 p-4 border border-white/10 hover:border-[#E63946] hover:bg-[#E63946]/5 transition-all group"
              >
                <div className="w-10 h-10 bg-[#E63946]/10 group-hover:bg-[#E63946] flex items-center justify-center transition-colors">
                  <c.Icon size={18} className="text-[#E63946] group-hover:text-white transition-colors" />
                </div>
                <div>
                  <div className="text-[10px] tracking-[0.2em] text-white/50">{c.label.toUpperCase()}</div>
                  <div className="text-sm font-semibold text-white">{c.value}</div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Form */}
        <div className="lg:col-span-7">
          <form
            onSubmit={onSubmit}
            data-testid="contact-form"
            className="bg-[#050B14] border border-white/10 p-6 sm:p-10 space-y-5"
          >
            <h3 className="font-display text-3xl">KIRIM PESAN</h3>

            <div className="grid sm:grid-cols-2 gap-5">
              <div>
                <label className="text-xs tracking-[0.2em] text-white/60">NAMA</label>
                <input
                  type="text"
                  required
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  data-testid="contact-input-name"
                  className="w-full bg-transparent border-b border-white/20 focus:border-[#E63946] outline-none py-2 mt-1 text-white"
                  placeholder="Nama lengkap"
                />
              </div>
              <div>
                <label className="text-xs tracking-[0.2em] text-white/60">EMAIL</label>
                <input
                  type="email"
                  required
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  data-testid="contact-input-email"
                  className="w-full bg-transparent border-b border-white/20 focus:border-[#E63946] outline-none py-2 mt-1 text-white"
                  placeholder="email@anda.com"
                />
              </div>
            </div>

            <div>
              <label className="text-xs tracking-[0.2em] text-white/60">PESAN</label>
              <textarea
                required
                rows={5}
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                data-testid="contact-input-message"
                className="w-full bg-transparent border-b border-white/20 focus:border-[#E63946] outline-none py-2 mt-1 text-white resize-none"
                placeholder="Tulis pesanmu di sini..."
              />
            </div>

            <button
              type="submit"
              data-testid="contact-submit"
              className="inline-flex items-center gap-2 bg-[#E63946] hover:bg-[#D62839] text-white px-7 py-3 font-bold tracking-wider text-sm transition-colors"
            >
              <Send size={16} /> KIRIM PESAN
            </button>

            {submitted && (
              <div
                data-testid="contact-success"
                className="text-sm text-[#E63946] font-semibold"
              >
                ✓ Pesan terkirim! Tim akan segera membalas.
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
